module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.name))]), _vm._v(" "), _c('van-dropdown-menu', [_c('van-dropdown-item', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "change": _vm.startIdChange
    },
    model: {
      value: (_vm.params.start_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "start_id", $$v)
      },
      expression: "params.start_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "2.5rem"
    }
  }), _vm._v(" "), _c('van-search', {
    attrs: {
      "placeholder": "搜索队伍"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "step-box"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active": 1000
    }
  }, _vm._l((_vm.list), function(subject, i) {
    return _c('van-step', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.show),
        expression: "subject.show"
      }],
      key: i
    }, [_c('p', {
      staticClass: "item-team-name"
    }, [_c('em', [_vm._v(_vm._s(i + 1))]), _vm._v(" " + _vm._s(subject.mingcheng))]), _vm._v(" "), _c('p', {
      staticClass: "item-team-desc"
    }, [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), _c('p', {
      staticClass: "item-team-time"
    }, [_vm._v("检录: "), _c('em', [_vm._v(_vm._s(subject.check_time))]), _vm._v("\n          检录2: "), _c('em', [_vm._v(_vm._s(subject.check_time2))]), _vm._v(" "), (subject.check_time3 != '00:00:00') ? _c('span', [_vm._v("检录3: "), _c('em', [_vm._v(_vm._s(subject.check_time3))])]) : _vm._e(), _vm._v("\n          比赛: "), _c('em', [_vm._v(_vm._s(subject.sai_time))]), _vm._v("\n        (预计时间)\n        ")])])
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c884e99a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiStartList.vue
// module id = 1589
// module chunks = 0